import { RoleNome } from '../generated/backend-enums.js';
/**
 * Quem pode ser responsável por um contato: os cargos do Atendimento. O backend tem a mesma lista
 * (`domain/mappings/contato/contato-responsavel.mapping.ts`) e um teste garante que as duas batem.
 */
export const CARGOS_DO_ATENDIMENTO = [
    RoleNome.ASSISTENTE_DE_ATENDIMENTO,
    RoleNome.ESTAGIARIO_DE_ATENDIMENTO,
    RoleNome.ATENDIMENTO,
    RoleNome.COORDENADOR_DE_ATENDIMENTO,
    RoleNome.GERENTE_DE_ATENDIMENTO,
    RoleNome.DIRETOR_DE_NEGOCIOS,
    RoleNome.DIRETOR_DE_PROJETOS,
];
